import React from "react";

const ArrowLeftIcon = ({ color = "#FFF", width = 16, height=25, className = "", ...props }) => (
        <svg width={width}
             height={height}
             viewBox="0 0 25 16" fill="none" xmlns="http://www.w3.org/2000/svg"
             className={className}
             {...props}
        >
            <path
                d="M23.5 9C24.0523 9 24.5 8.55228 24.5 8C24.5 7.44772 24.0523 7 23.5 7L23.5 9ZM0.792892 7.2929C0.402369 7.68342 0.402369 8.31658 0.792893 8.70711L7.15686 15.0711C7.54738 15.4616 8.18054 15.4616 8.57107 15.0711C8.96159 14.6805 8.96159 14.0474 8.57107 13.6569L2.91421 8L8.57107 2.34315C8.96159 1.95262 8.96159 1.31946 8.57107 0.928933C8.18054 0.538409 7.54738 0.538409 7.15685 0.928934L0.792892 7.2929ZM23.5 7L1.5 7L1.5 9L23.5 9L23.5 7Z"
                fill={color}/>
        </svg>
    )
;

export default ArrowLeftIcon;